import { gql } from '@apollo/client'

export const TrackChangeFragment = gql`
    fragment trackChangeFragment on TrackChange {
        id
        changeType
        changeDateTime
        status
        changedText
        familyId
        userProfileInfo {
            firstName
            lastName
            imageUrl
        }
        elementId
        elementType
        contentItemId
        contentItemElementId
        rootContentItemId
        partType
        isSharedContentItem
        approvedOrRejectedDateTime
        acceptedRejectedProfileInfo {
            firstName
            lastName
            imageUrl
        }
        trackChangeComments {
            id
            comment
            userId
            createdDate
            updatedDate
            trackChangeId
            userProfileInfo {
                firstName
                lastName
                imageUrl
            }
        }
        trackChangeTypeToChangedTexts {
            changedText
            contentItemElementId
            trackChangeType
            authoredUserId
        }
    }
`
